<template>
  <div class="free-text-wrapper">
    <div v-if="question" class="question-title">
    <h2 class="question-choice">{{ question.intro }}</h2>

    <div class="content-wrapper">
      <div style="display: flex; justify-content: center;">
        <div
          v-for="option in question.config.options"
          :key="option.value"
          class="position-relative"
        >
          <label class="w-100 h-100 my-0">

            <float-label>
                <textarea
                  :id="option.value"
                  class="form-control input-freetext"
                  rows="4"
                  :placeholder="option.info || 'Geben Sie hier Ihren Text ein..'"
                  @input="update"
                  v-model="inputtext"
                  required
                ></textarea>
              </float-label>
          </label>
        </div>
      </div>
    </div>
  </div>
  </div>
  
</template>

<script>

export default {
  name: 'free-text-question',
  data() {
    return {
      inputtext: ""
    }
  },
  computed: {
    question: function () {
      return this.$store.state.questions[0] || false
    }
  },
  mounted() {
    if(this.$store.state.questions[0].selectedAnswers != null){
      this.inputtext = this.$store.state.questions[0].selectedAnswers.displayValue;
    } else {
      this.inputtext = "";
    }
  },
  methods: {
    update(e) {
      if(this.inputtext.length >=3) {
        this.$store.commit('updateSelectedAnswers', { answer: e.target.id, displayValue: this.inputtext})
      }
    }
  },
}
</script>
